import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import CallBackComponent from './PopupSharedComponents/CallBackComponent';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {closeModal, returnToLobby} from '../cellcomAbroadBlockSlice';
import {removeCapSoc} from '../Shared/abroadThunk';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';

const CapSocPopup = (props) => {
  function getCurrentNumber() {
    return props.data.epiStyleInitializationData.businessIndividualLobby
      ? props.data.businessIndividualData.selectedAccountNumber
      : props.data.otpData.isFamilyProcess
      ? props.data.otpDataChildren.otpPhone
      : props.selfcarePage.selectedSubscriber?.productSubscriberNo || props.authentication.loginData.userDetails.contactNumber;
  }

  function cancelCapPackage() {
    const removeSocData = {
      mobile: getCurrentNumber(),
    };
    props.removeCapSoc(removeSocData);
  }

  function handleOnOpenWhatsApp() {
    const whatsAppLink = `https://wa.me/${Config.numberCallCenterAbroad}?force_isolation=true&text=`;
    let win = window.open(whatsAppLink, '_blank');
    win.focus();
  }

  return (
    <div className='capSocPopup'>
      <div>
        <Image src={require('../images/icon-alert.svg')} alt='icon-alert' />
      </div>
      <PopupDescriptionComponent boldDescription={'שמנו לב שתקרת החיוב שביקשת נוצלה במלואה ומספרך נחסם אוטומטית לשימושים בחו"ל'} />
      <div className='fs20'>באפשרותך</div>
      <div className='actions'>
        <div>
          <BtnWhiteBlackBorderBigSize
            text={' לבטל את החסימה'}
            onclick={() => {
              cancelCapPackage();
            }}
          />
        </div>
        <div>
          <BtnWhiteBlackBorderBigSize
            text={' להישאר חסום ולרכוש חבילת גלישה'}
            onclick={() => {
              props.returnToLobby({activeTab: props.data.activeLobbyTab});
              EpiContext.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
              props.closeModal();
            }}
          />
        </div>
      </div>

      <div className='whatsApp'>
        <div className='fs20'>כדי להגדיר מחדש את תקרת החיוב</div>
        <BtnWhiteBlackBorderBigSize
          text={
            <span>
              פנו לנציג ב <span className='primary'>WhatsApp</span>
              <Image src={require('../images/whatsapp.svg')} alt='whatsapp' />
            </span>
          }
          onclick={() => {
            handleOnOpenWhatsApp();
          }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    selfcarePage: state.selfcarePage,
    authentication: state.authentication,
  };
};
const mapDispatchToProps = {
  closeModal,
  removeCapSoc,
  returnToLobby,
};
export default connect(mapStateToProps, mapDispatchToProps)(CapSocPopup);
